import { Config } from 'next-i18n-router/dist/types';

export const locales = ['en', 'ar'] as const;
export const defaultLocale = 'en';
export const cookieName = 'i18next';
export const defaultNS = 'common';

const i18nConfig: Config = {
  locales,
  defaultLocale,
};

export function getOptions(lng = defaultLocale, ns: string | string[] = defaultNS) {
  return {
    supportedLngs: locales,
    fallbackLng: defaultLocale,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}

export default i18nConfig;
